"use client";

// Minimal global-error boundary. Next.js requires this to render its own
// <html>/<body> because it sits ABOVE the root layout. Keep it free of any
// context, providers, or imports so it can prerender without crashing during
// `next build` (which renders this page in isolation).
export default function GlobalError({
  error,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  return (
    <html lang="en">
      <body
        style={{
          fontFamily: "system-ui, -apple-system, sans-serif",
          margin: 0,
          minHeight: "100vh",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          background: "#fff",
          color: "#111",
        }}
      >
        <div style={{ maxWidth: 480, padding: 32, textAlign: "center" }}>
          <h1 style={{ fontSize: 24, fontWeight: 600, margin: 0 }}>
            Something went wrong
          </h1>
          <p style={{ marginTop: 12, color: "#555" }}>
            An unexpected error occurred. Try refreshing the page.
          </p>
          {error?.digest ? (
            <p
              style={{
                marginTop: 16,
                fontSize: 12,
                color: "#888",
                fontFamily: "monospace",
              }}
            >
              Reference: {error.digest}
            </p>
          ) : null}
        </div>
      </body>
    </html>
  );
}
